import React, { useState } from 'react';
import { AddData } from '../../../../../components';
import { useStore } from '../../../../../stores';
import {
    Design_Illustration,
    Digital_Marketing,
    Mobile_Web_Development,
    Photography_Videography,
    Writing_Reporting
} from './../../../../../constants/skillsCategories';

const AddIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/AddIcon.svg`;

const SkillsSection = ({ SelectedBrief,getAadditionalData,Message}) => {
    const { uiStore } = useStore();
    const [AddDataID, setAddDataID] = useState('');

    function copyToClipboard(e) {
        navigator.clipboard.writeText(e.target.innerText)
            .then(() => { })
            .catch(err => {
                uiStore.showNotification(`Failed to copy text: "${err}"`, "warning");
            });
    };
    function getAddDataID(e) {
        const ID = e.currentTarget.id;
        setAddDataID(ID);
    };
    function getSkills() {
        let skills = [];
        const serviceCategory = ['Design and Illustration', 'Digital Marketing and Social Media', 'Mobile and Web Development', 'Photography and Videography', 'Writing Services', 'Other Services']

        for (let i = 0; i < serviceCategory.length; i++) {
            if (SelectedBrief.serviceCategory.includes('Design and Illustration')) {
                skills = [...skills, ...Design_Illustration];
            };
            if (SelectedBrief.serviceCategory.includes('Digital Marketing and Social Media')) {
                skills = [...skills, ...Digital_Marketing];
            };
            if (SelectedBrief.serviceCategory.includes('Mobile and Web Development')) {
                skills = [...skills, ...Mobile_Web_Development];
            };
            if (SelectedBrief.serviceCategory.includes('Photography and Videography')) {
                skills = [...skills, ...Photography_Videography];
            };
            if (SelectedBrief.serviceCategory.includes('Writing Services')) {
                skills = [...skills, ...Writing_Reporting];
            };
            if (SelectedBrief.serviceCategory.includes('Other Services')) {
                skills = [];
                skills = [...Writing_Reporting, ...Design_Illustration, ...Digital_Marketing, ...Mobile_Web_Development, ...Photography_Videography];
            };
        };
        return skills;
    };

    return (
        <>
            <div className='textAreacontainer' style={{ maxHeight: '33.5%', width: '95%', padding: '1%', position: 'relative' }}>
                <p style={{ fontWeight: '700', fontSize: '14px', lineHeight: '24px' }} className='p_with_span_add'>
                    Project Links<span className='the_span'><img src={AddIcon} alt='add icon' id='prolink' onClick={getAddDataID} /></span>
                </p>
                {AddDataID === 'prolink' && (
                    <AddData
                        SelectedBrief={SelectedBrief}
                        InputType='link'
                        id='link'
                        getData={getAadditionalData}
                        closeComponent={() => { setAddDataID('') }}
                    />
                )}
                <div className='minidisplaybox'>
                    <div className='minidisplaybox_inner'>
                        {Array.isArray(SelectedBrief?.project?.projectLinks) && SelectedBrief.project.projectLinks.length > 0 ?
                            SelectedBrief.project.projectLinks.map((item, index) => {
                                if (typeof item === 'object' && item.url !== undefined && item.url !== null && item.url !== '') {
                                    return (
                                        <p
                                            key={index}
                                            onClick={copyToClipboard}
                                            className='mini_p_kids'
                                            style={{ fontSize: '12px', cursor: 'pointer' }}
                                        >
                                            {item.url}
                                        </p>
                                    );
                                } else {
                                    return null;
                                }
                            })
                            : Array.isArray(SelectedBrief?.projectLinks) && SelectedBrief.projectLinks.length > 0 ?
                                SelectedBrief.projectLinks.map((item, index) => {
                                    if (typeof item === 'object' && item.url !== undefined && item.url !== null && item.url !== '') {
                                        return (
                                            <p
                                                key={index}
                                                onClick={copyToClipboard}
                                                className='mini_p_kids'
                                                style={{ fontSize: '12px', cursor: 'pointer' }}
                                            >
                                                {item.url}
                                            </p>
                                        );
                                    } else {
                                        return null;
                                    }
                                })
                                : null
                        }
                    </div>
                </div>
            </div>

            <div className='textAreacontainer' style={{ maxHeight: '35.5%', width: '95%', padding: '0% 1%', position: 'relative' }}>
                <p style={{ fontWeight: '700', fontSize: '14px', lineHeight: '24px' }} className='p_with_span_add'>
                    Skills Of Professional
                    <span className='the_span'>
                        {!Object.keys(SelectedBrief).includes("brief") &&
                            <img src={AddIcon} alt='add icon' id='proskill' onClick={getAddDataID} />
                        }
                    </span>
                </p>
                {AddDataID === 'proskill' && (
                    <AddData SelectedBrief={SelectedBrief} id='proskill' InputType='menudropdown' getData={getAadditionalData} closeComponent={() => { setAddDataID('') }} MenuItems={getSkills()}/>
                )}

                <div className='minidisplaybox' style={{ overflow: 'hidden' }}>
                    <div className='minidisplaybox_inner'>
                        {Array.isArray(SelectedBrief?.skillsOfProfessional) && SelectedBrief.skillsOfProfessional.length > 0 ?
                            SelectedBrief.skillsOfProfessional.map((item, index) => (
                                <p key={index} className='mini_p_kids' style={{ fontSize: '12px' }}>{item}</p>
                            )) 
                            :
                            Array.isArray(SelectedBrief?.brief?.skillsOfProfessional) && SelectedBrief.brief.skillsOfProfessional.length > 0 ?
                                SelectedBrief.brief.skillsOfProfessional.map((item, index) => (
                                    <p key={index} className='mini_p_kids' style={{ fontSize: '12px' }}>{item}</p>
                                ))
                                :
                            ''
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default SkillsSection;